import { render } from "./AppComment.vue?vue&type=template&id=34f1424c&scoped=true"
import script from "./AppComment.vue?vue&type=script&lang=js"
export * from "./AppComment.vue?vue&type=script&lang=js"

import "./AppComment.vue?vue&type=style&index=0&id=34f1424c&scoped=true&lang=scss"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-34f1424c"]])

export default __exports__